const envApiUrl = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL;
const isLocalHost = (url: string) => /(^|\/\/)(localhost|127\.0\.0\.1)(:\d+)?(?:\/|$)/.test(url);
const isAbsoluteUrl = (url: string) => /^https?:\/\/|^\/\//.test(url);
const trimSlash = (value: string) => value.replace(/\/+$/, '');

const STAGING_HOSTNAMES = ['insightstage.smartx.ir', 'www.insightstage.smartx.ir'];
const PRODUCTION_HOSTNAMES = ['insight.smartx.ir', 'www.insight.smartx.ir'];
export const DEMO_HOSTNAMES = ['demo.insight.smartx.ir', 'www.demo.insight.smartx.ir'];

export const isDemoHost = (): boolean => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_DEMO_MODE === 'true';
  }
  if (process.env.REACT_APP_DEMO_MODE === 'true') {
    return true;
  }
  return DEMO_HOSTNAMES.includes(window.location.hostname);
};

export const INSIGHT_PROD_URL = trimSlash(
  process.env.REACT_APP_INSIGHT_PROD_URL || 'https://insight.smartx.ir'
);
export const INSIGHT_STAGE_URL = trimSlash(
  process.env.REACT_APP_INSIGHT_STAGE_URL || 'https://insightstage.smartx.ir'
);

export const isStagingHost = (): boolean => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_DEPLOYMENT === 'stage';
  }
  if (process.env.REACT_APP_DEPLOYMENT === 'stage') {
    return true;
  }
  if (process.env.REACT_APP_DEPLOYMENT === 'prod') {
    return false;
  }
  return STAGING_HOSTNAMES.includes(window.location.hostname);
};

export const isProductionInsightHost = (): boolean => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_DEPLOYMENT === 'prod';
  }
  if (process.env.REACT_APP_DEPLOYMENT === 'prod') {
    return true;
  }
  if (process.env.REACT_APP_DEPLOYMENT === 'stage') {
    return false;
  }
  return PRODUCTION_HOSTNAMES.includes(window.location.hostname);
};

const resolveApiUrl = () => {
  if (envApiUrl) {
    const normalizedApiUrl = trimSlash(envApiUrl);

    // If env is explicitly localhost while app is loaded from non-localhost,
    // fallback to same-origin to avoid accidental local requests in production/stage.
    if (
      typeof window !== 'undefined' &&
      isLocalHost(normalizedApiUrl) &&
      !isLocalHost(window.location.host)
    ) {
      return `${window.location.origin}/api`;
    }

    // Support path-only env values like `/api`.
    if (isAbsoluteUrl(normalizedApiUrl)) {
      return normalizedApiUrl;
    }

    return `${window.location.origin}${normalizedApiUrl.startsWith('/') ? '' : '/'}${normalizedApiUrl}`;
  }

  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api`;
  }

  return process.env.NODE_ENV === 'production'
    ? 'https://insightstage.smartx.ir/api'
    : 'http://localhost:8000/api';
};

const config = {
  API_URL: resolveApiUrl(),
  STAGE_NO_AUTH: process.env.REACT_APP_DISABLE_AUTH === 'true',
  ENV: process.env.NODE_ENV || 'development',
  INSIGHT_PROD_URL,
  INSIGHT_STAGE_URL,
  isStagingHost,
  isProductionInsightHost,
  isDemoHost,
  DEMO_HOSTNAMES,
};

export default config;
